/**
 * @author        joseph.murphy@zumper.com (murph)
 * @copyright     Copyright (c) 2023, Zumper
 */

import { BUTTON_CLICKED_ON_DETAIL_TYPES, EVENT_NAMES, PROP_NAMES } from '@zcode/mixpanel'
import { useCallback, useContext } from 'react'
import { DetailPageContext } from '../DetailPageContext'

export function useDetailMixpanelClick(
  buttonClickedOnDetail: keyof typeof BUTTON_CLICKED_ON_DETAIL_TYPES
) {
  const context = useContext(DetailPageContext)
  const mixpanelEvent = context?.MixpanelThunks.mixpanelEvent

  return useCallback(
    () =>
      mixpanelEvent?.(EVENT_NAMES.CLICK, undefined, {
        [PROP_NAMES.BUTTON_CLICKED_ON_DETAIL]:
          BUTTON_CLICKED_ON_DETAIL_TYPES[buttonClickedOnDetail],
      }),
    [buttonClickedOnDetail, mixpanelEvent]
  )
}
